import * as React from 'react';
import {
  Datagrid,
  DateField,
  List,
  SimpleShowLayout,
  TextField,

  TextInput, required,

} from "react-admin";
import EditView from "../../../components/EditView";
import CreateView from "../../../components/CreateView";
import ShowView from "../../../components/ShowView";

import { ColorField, ColorInput } from 'react-admin-color-input';

export const PreferCallList = (props) => (

  <List {...props} sort={{ field: 'createdAt', order: 'ASC' }} >
    <Datagrid rowClick="edit">
      <TextField source="title" label="عنوان" />
      <DateField locales={"fa-IR"} source="updatedAt" />
      <ColorField source="stColor" label="رنگ نوع تماس" />

    </Datagrid>
  </List>
);

export const PreferCallEdit = (props) => (
  <EditView {...props} perPage={10}>
    <TextInput source="title" validate={required()} />
    <ColorInput source="stColor" label="رنگ نوع تماس" />
  </EditView>
);

export const PreferCallShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <TextField source="title" />
      <TextField source="objectId" />
      <ColorField source="stColor" label="رنگ نوع تماس" />

    </SimpleShowLayout>
  </ShowView>
);

export const PreferCallCreate = (props) => (
  <CreateView {...props}>
    <TextInput source="title" label="عنوان" />
    <ColorInput source="stColor" label="رنگ نوع تماس" />
  </CreateView>
);
